var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.message || !!_vm.errors.length),expression:"message || !!errors.length"}],staticClass:"text-warning text-sm"},[_vm._v(" "+_vm._s(_vm.message ? _vm.message : _vm.errors[0])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }